export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const API_KEY = 'a7d19be7-bf4e-4b10-9a47-f6ba072319ea';
export const MODAL_CLOSE_SEC = 2.5;
